import { motion } from "framer-motion";

export default function CTA() {
    return (
        <section className="py-24 px-4 relative overflow-visible">
            <motion.div
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, ease: "easeOut" }}
                className="max-w-7xl mx-auto relative rounded-3xl bg-neon text-black border border-black/5 shadow-2xl overflow-visible"
            >
                {/* Background Decoration: Wrapped in its own overflow-hidden container */}
                <div className="absolute inset-0 pointer-events-none overflow-hidden rounded-3xl">
                    <div className="absolute top-0 left-0 w-full h-[200%] bg-black/5 -rotate-45 translate-x-[-20%] translate-y-[-50%]" />
                </div>

                {/* Mobile Layout */}
                <div className="flex flex-col lg:hidden relative z-10 px-8 pt-24 pb-12">
                    {/* Image — Popping out from the top on mobile */}
                    <motion.div
                        initial={{ opacity: 0, y: 20, rotate: -5 }}
                        whileInView={{ opacity: 1, y: 0, rotate: -8 }}
                        viewport={{ once: true }}
                        transition={{ delay: 0.2, duration: 0.8, ease: "easeOut" }}
                        className="flex justify-center -mt-44 mb-12"
                    >
                        <img
                            src="/img/digrify1.png"
                            alt="Digrify App Preview"
                            className="w-[280px] h-auto drop-shadow-[0_40px_60px_rgba(0,0,0,0.4)]"
                        />
                    </motion.div>

                    {/* Text */}
                    <div className="text-left">
                        <h2 className="text-2xl md:text-3xl font-bold mb-6 leading-tight tracking-tight text-black">
                            What's New? Introducing my latest <span className="bg-black text-neon px-2 py-0.5 rounded">digital</span> product
                        </h2>
                        <p className="text-base font-bold mb-0 text-black/70 leading-relaxed">
                            Digrify is a modern Islamic app designed to help users stay consistent with their daily dhikr, prayers, and spiritual habits.
                        </p>
                    </div>
                </div>

                {/* Desktop Layout — keep the dramatic overlapping effect */}
                <div className="hidden lg:grid grid-cols-2 gap-8 items-center relative z-10 px-16 h-[350px]">
                    {/* Image Column — dramatic overlay on desktop only */}
                    <div className="relative h-full flex items-center justify-start order-1">
                        <motion.div
                            initial={{ opacity: 0, scale: 0.8, rotate: -5 }}
                            whileInView={{ opacity: 1, scale: 1.15, rotate: -8 }}
                            viewport={{ once: true }}
                            transition={{ delay: 0.3, duration: 1, ease: "circOut" }}
                            className="absolute -top-48 left-0 -translate-x-12 w-[380px] z-20"
                        >
                            <img
                                src="/img/digrify1.png"
                                alt="Digrify App Preview"
                                className="w-full h-auto drop-shadow-[0_45px_70px_rgba(0,0,0,0.5)]"
                            />
                        </motion.div>
                    </div>

                    {/* Text Column */}
                    <div className="text-left order-2">
                        <h2 className="text-3xl font-bold mb-6 leading-tight tracking-tight text-black">
                            What's New? Introducing my latest <span className="bg-black text-neon px-2 py-0.5 rounded">digital</span> product
                        </h2>
                        <p className="text-lg font-bold text-black/70 leading-relaxed max-w-lg">
                            Digrify is a modern Islamic app designed to help users stay consistent with their daily dhikr, prayers, and spiritual habits.
                        </p>
                    </div>
                </div>
            </motion.div>
        </section>
    );
}
